export { default as LandingPage } from './LandingPage/LandingPage'
export { default as AboutPage } from './AboutPage/AboutPage'
export { default as PeoplePage } from './PeoplePage/PeoplePage'
export { default as AcademicsPage } from './AcademicsPage/AcademicsPage'
export { default as ActivitiesPage } from './ActivitiesPage/ActivitiesPage'
export { default as ContactPage } from './ContactPage/ContactPage'
export { default as PlacementsPage } from './PlacementsPage/PlacementsPage'
export { default as ResourcesPage } from './ResourcesPage/ResourcesPage'
export { default as FacilitiesPage } from './FacilitiesPage/FacilitiesPage'
export { default as ClubProfilePage } from './ClubProfilePage/ClubProfilePage'
export { default as FacultyProfilePage } from './FacultyProfilePage/FacultyProfilePage'
export { default as TeamPage } from './TeamPage/TeamPage'
export { default as GalleryPage } from './GalleryPage/GalleryPage'
export { default as AnnouncementPage } from './AnnouncementPage/AnnouncementPage'
export { default as AdmissionPage } from './AdmissionPage/AdmissionPage'




// -- ADMIN --

export { default as Login } from './Admin/Auth/Login/Login'
export { default as Profile } from './Admin/Profile/Profile'
export { default as Register } from './Admin/Auth/Register/Register'
export { default as ClubsPage } from './Admin/ClubsPage/ClubsPage'